/* Native disclosure menus keep links usable without JavaScript. */
document.addEventListener('toggle', function (event) {
  const opened = event.target;
  if (!opened.matches?.('.dm-nav-disclosure[open]')) return;
  opened.closest('.dm-nav').querySelectorAll('.dm-nav-disclosure[open]').forEach(function (other) {
    if (other !== opened) other.open = false;
  });
}, true);
document.addEventListener('click', function (event) {
  document.querySelectorAll('.dm-nav--desktop .dm-nav-disclosure[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  const menu = document.activeElement.closest?.('.dm-nav-disclosure[open]');
  if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
});
document.addEventListener('focusin', function (event) {
  document.querySelectorAll('.dm-nav--desktop .dm-nav-disclosure[open]').forEach(function (menu) {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
